export default __webpack_public_path__ + "static/media/art-blk-2.96c48855.png";